import {createEntityService} from "base/entity/service";
import {Service as DefaultService} from "app/common/service";
import {
    createZoningareas,
    createZoningareasList,
    zoningareas_api_adapter,
    zoningareas_list_api_adapter,
} from "app/zoningareas/Zoningareas";

const entityService = createEntityService(
    "/api/app/zoningareas",
    createZoningareas,
    createZoningareasList,
    zoningareas_api_adapter,
    zoningareas_list_api_adapter
);

export const ZoningareasService = DefaultService(entityService);
